import React, { Component } from 'react'
import { infoScreenAriaLabel } from '../Constants/AriaLabelText'
import { injectIntl, FormattedMessage } from 'react-intl'


class InfoProfileStrength extends Component {
  render() {
    const { intl } = this.props
    return (
      <div>
        <div className="container-fluid bg-white text-center light-gray-bg2 score-calculated">
          <div className="row">
            <div className="col-sm-12 margin-4p">
              <div className="close-icon">
                <a
                  aria-label={infoScreenAriaLabel(intl)['close']}
                  href="javascript:void(0);"
                  onClick={() => this.props.hideModal()}>
                  {' '}
                  X
                </a>
              </div>
              <h2 className="margin-bottom-40">
                {' '}
                <FormattedMessage
                  id="infoProfileStrength.heading.howScoreCalculated"
                  defaultMessage="How is your score calculated?"
                />
              </h2>
              <div id="progressBar" className="margin-auto">
                <div className="position yellow-zone" />
              </div>
              <br />
              <p className="text-normal margin-bottom-30">
                <FormattedMessage
                  id="infoProfileStrength.paragraph.baseScore"
                  defaultMessage="Base score is based on 3 key aspects of your LinkedIn profile"
                />
                {' '}
              </p>
              <div className="hr-doted-line"> </div>
              <div className="row">
                <div className="col-sm-4">
                  <div className="vr-doted-line" />
                  <div className="bg-white border-gray2 height40">
                    <div className="border-bottom-gray pad-mar-16">
                      <h3 className="padding-top-20">
                        <FormattedMessage
                          id="infoProfileStrength.heading.content"
                          defaultMessage="Content"
                        />
                      </h3>
                      <p>
                        <FormattedMessage
                          id="infoProfileStrength.paragraph.content"
                          defaultMessage="Lorem ipsum integer efficitur euismod auctor. Sed consequat blandit ligula a vehicula."
                        />
                        {' '}
                      </p>
                      <img
                        src={`${process.env.APP_BASE_URL}dist/images/score-graph01.png`}
                        alt="Score Graph"
                      />
                    </div>
                    <ul>
                      <li className="dart-icon">
                        <FormattedMessage
                          id="infoProfileStrength.list.content.completeness"
                          defaultMessage="Completeness"
                        />
                      </li>
                      <li className="dart-icon">
                        <FormattedMessage
                          id="infoProfileStrength.list.content.importantCategories"
                          defaultMessage="Important Categories"
                        />
                      </li>
                      <li className="dart-icon">
                        <FormattedMessage
                          id="infoProfileStrength.list.content.impact"
                          defaultMessage="Impact"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="vr-doted-line" />
                  <div className="bg-white border-gray2 height40">
                    <div className="border-bottom-gray pad-mar-16">
                      <h3 className="padding-top-20">
                        <FormattedMessage
                          id="infoProfileStrength.heading.skill"
                          defaultMessage="Skill"
                        />
                      </h3>
                      <p>
                        <FormattedMessage
                          id="infoProfileStrength.paragraph.skill"
                          defaultMessage="Integer efficitur euismod auctor. Sed consequat blandit ligula a vehicula."
                        />
                        {' '}
                      </p>
                      <img
                        src={`${process.env.APP_BASE_URL}dist/images/score-graph02.png`}
                        alt="Score Graph"
                      />
                    </div>
                    <ul>
                      <li className="dart-icon">
                        <FormattedMessage
                          id="infoProfileStrength.list.skill.softSkill"
                          defaultMessage="Soft Skill"
                        />
                      </li>
                      <li className="dart-icon">
                        <FormattedMessage
                          id="infoProfileStrength.list.skill.hardSkillIncluded"
                          defaultMessage="Hard skill Included"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="vr-doted-line2" />
                  <div className="bg-white  border-gray2 height40">
                    <div className="border-bottom-gray pad-mar-16">
                      <h3 className="padding-top-20">
                        <FormattedMessage
                          id="infoProfileStrength.heading.profileVisibility"
                          defaultMessage="Profile Visibility"
                        />
                      </h3>
                      <p>
                        {' '}
                        <FormattedMessage
                          id="infoProfileStrength.paragraph.profileVisibility"
                          defaultMessage="Cras a elit sit amet odio hendrerit euismod. Donec lacinia convallis tincidunt."
                        />
                        {' '}
                      </p>
                      <img
                        src={`${process.env.APP_BASE_URL}dist/images/score-graph02.png`}
                        alt="Score Graph"
                      />
                    </div>
                    <ul>
                      <li className="dart-icon">
                        <FormattedMessage
                          id="infoProfileStrength.list.profileVisibility.numberOfConnections"
                          defaultMessage="Number of Connections"
                        />
                      </li>
                      <li className="dart-icon">
                        <FormattedMessage
                          id="infoProfileStrength.list.profileVisibility.importantCategories"
                          defaultMessage="Important categories"
                        />
                      </li>
                      <li className="dart-icon">
                        <FormattedMessage
                          id="infoProfileStrength.list.profileVisibility.impact"
                          defaultMessage="Impact"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(InfoProfileStrength)
